<template>
  <div class="footer">
    <div class="footer-box">
      <div class="logo-box">
        <div class="logo-name">
          <img src="../assets/logo.png" class="logo-1" />
          <p>HappyPlata</p>
        </div>
      </div>
      <div class="connect">
        <!-- <p><img src="../assets/tel.png" alt="" /> 938574080</p> -->
        <p><img src="../assets/email.png" alt="" /> Correo electrónico: cliente@grupomoralescueva.com</p>
        <p><img src="../assets/address.png" alt="" /> Dirección: Av. Panamericana Mz. B-1 Lote 7 Urb. San Ramon</p>
      </div>

    </div>
    <div class="copyright">
      © 2024 HappyPlata All rights reserved.

    </div>

  </div>
</template>
<style lang="less" scoped>
.footer {
  margin: 40px;
  background: #E5E7EB;
  border-radius: 16px;
  overflow: hidden;

  .footer-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;

    .logo-box {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-left: 320px;

      .logo-name {

        .logo-1 {
          // width: 64px;
          height: 36px;
          margin-bottom: 14px;
        }

        p {
          font-family: BalooBhaijaan, BalooBhaijaan;
          font-weight: 600;
          font-size: 24px;
          color: #333333;
        }
      }

      .text {
        font-family: Roboto, Roboto;
        font-weight: 400;
        font-size: 20px;
        color: rgba(51, 51, 51, 0.8);
        margin-top: 20px;
      }
    }

    .connect {
      font-family: Baskerville, Baskerville;
      font-weight: 600;
      font-size: 18px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-right: 200px;

      p {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        max-width: 500px;
        margin-right: 20px;

        img {
          height: 16px;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
  }

  .copyright {
    font-family: Baskerville;
    font-size: 14px;
    color: #999999;
    text-align: center;
    height: 48px;
    line-height: 48px;
    border-top: 1px solid #D7D8DE;
    margin: 0 320px;
    margin-top: 40px;
  }
}
</style>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    send() {
      alert("send success");
    },
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "about" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "offers" });
          break;
        case 5:
          this.$router.push({ path: "contact" });
          break;
        // case 5: this.$router.push({ path: "cooperate" }); break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>